import React from "react";

import Player from "../Player/Player";
import api from "../utils/api";
import { useOutletContext } from "react-router-dom";
import ProjectedStartersTable from "../lib/components/ProjectedStartersTable";


const Players = ({ playerData }) => {
    const { managerName } = useOutletContext();
    const players = playerData.filter(player => player.manager === managerName);

    const handleContractUpdate = (id, contract) => {
        api.post('/api/v2/players/contract/update', {id: id, contract: Number(contract)}).then(() => {
            console.log(`Updated ${id}, ${contract}`);
        }).catch(res => {
            console.error(res);
        });
    }

    return (<div id="players">
        <h3>Players</h3>
        <h4>Projected Starters</h4>
        <div>
            <ProjectedStartersTable managerPlayerData={players} />
        </div>
        <h4>Contract updates</h4>
        <div>
            {players.map((player, index) => (
                <Player index={index} playerData={player} handleContractUpdate={handleContractUpdate} canUpdate={true}/>
            ))}
        </div>
    </div>)
};

export default Players;
